import { UserNumber } from '../codegen/graphql';

export type ContactNumberInput = {
    code: string;
    number: string;
};

export function mapContactNumber(
    contactNumber: UserNumber | undefined | null,
): ContactNumberInput {
    const code = `${contactNumber?.countryCode ?? ''}/${
        contactNumber?.dialingCode ?? ''
    }`;
    return {
        code: code === '/' ? '' : code,
        number: contactNumber?.number ?? '',
    };
}
